// import TabBar from '../../components/TabBar.vue'
// import load from '../../components/Load.vue'
import {
  info
} from '../../api/profile'
export default {
  data() {
    return {
      userInfo: { //用户信息

      },

    }
  },
  created() {},
  methods: {
    headImg(v) {
      return v ? v : require('../image/headimg.png')
    },
     info() {
      // var id = localStorage.getItem('id');
       info().then(res=>{
        console.log(res)
        if(res.error_code==0){
          this.userInfo = res.data;
        }
      })
    }
  },
  filters: {},
  computed: {},
  components: {
    // TabBar,
    // load
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/js.js